var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinTrue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:pin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.53759 2.28083C8.9185 2.0265 9.10925 1.89933 9.31634 1.92033C9.524 1.94075 9.68559 2.10233 10.0093 2.42608L11.5738 3.99058C11.8976 4.31433 12.0592 4.47591 12.0796 4.68358C12.1 4.89125 11.9734 5.08141 11.7197 5.46233L10.7572 6.90491C10.4299 7.39666 10.266 7.64225 10.1353 7.90475C10.0384 8.09918 9.95518 8.30014 9.88625 8.50616C9.79292 8.78441 9.73459 9.07433 9.61909 9.65358L9.50825 10.2107L9.50709 10.2142C9.48792 10.3087 9.44563 10.3969 9.384 10.4711C9.32236 10.5452 9.24331 10.603 9.1539 10.6391C9.0645 10.6752 8.96754 10.6886 8.87169 10.6781C8.77584 10.6675 8.6841 10.6334 8.60467 10.5787L8.60175 10.5764L8.586 10.5659C6.56856 9.16785 4.81975 7.41745 3.4235 5.39875L3.42117 5.39525C3.3665 5.31582 3.33238 5.22408 3.32185 5.12823C3.31132 5.03238 3.32471 4.93542 3.36083 4.84601C3.39695 4.75661 3.45467 4.67756 3.52882 4.61592C3.60298 4.55429 3.69125 4.512 3.78575 4.49283L3.78925 4.49225L4.34634 4.38083C4.92559 4.26475 5.2155 4.207 5.49375 4.11366C5.69958 4.04471 5.90035 3.96148 6.09459 3.86458C6.35709 3.73391 6.60325 3.57 7.095 3.24216L8.53759 2.28083Z",
    stroke: "#00ABFF",
    strokeWidth: 1.16667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.91699 11.0833L5.54199 8.45834",
    stroke: "#00ABFF",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinTrue);
export default __webpack_public_path__ + "static/media/pin-true.0ab4709e3018f48eaf20bdd8a854ce36.svg";
export { ForwardRef as ReactComponent };